import React from 'react'
import { motion } from 'framer-motion'

const item = (delay) => ({
  initial:    { opacity: 0, y: 16 },
  animate:    { opacity: 1, y: 0 },
  transition: { duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] },
})

export default function Hero({ title, heroImg }) {
  return (
    <div className="arc-hero">
      {heroImg && (
        <div className="arc-hero__bg">
          <img src={heroImg} alt={title} />
        </div>
      )}
      <div className="arc-hero__overlay" />
      <div className="arc-hero__content">
        <motion.span className="arc-hero__eyebrow" {...item(0.1)}>
          Le Journey · Journal
        </motion.span>
        <motion.h1 className="arc-hero__title" {...item(0.25)}>
          {title}
        </motion.h1>
      </div>
    </div>
  )
}
